import React, { FC } from "react"
import { PostContentBodyDIV, PostContentWrapperDIV } from "./PostContent.styles"
import SocialShare from "@components/SocialShare/SocialShare"
import ArticleNav from "@components/ArticleNav/ArticleNav"
import AuthorByline from "@components/AuthorByline/AuthorByline"
import { PostTemplatePostFragmentFragment } from "@graphqlTypes"
import Content from "@components/Content/Content"
import SocialShareCallout from "../SocialShareCallout/SocialShareCallout"

const PostContent: FC<{
  authors: PostTemplatePostFragmentFragment["authors"]
  content: PostTemplatePostFragmentFragment["content"]
  fullUrl: string
  hideArticleNav?: boolean
  hideAuthors?: boolean
  hideSocialShare?: boolean
  title: string
}> = ({
  authors,
  content,
  fullUrl,
  hideArticleNav,
  hideAuthors,
  hideSocialShare,
  title,
}) => (
    <PostContentWrapperDIV className="PostContent">
      <PostContentBodyDIV>
        {!hideArticleNav && <ArticleNav />}
        {!hideSocialShare && <SocialShare title={title} url={fullUrl} />}
        {content && <Content content={content} />}
        {!hideSocialShare && <SocialShareCallout title={title} url={fullUrl} />}
        {!hideAuthors && authors &&
          authors.map((author) => (
            <AuthorByline
              key={author?.name}
              bio={author?.bio?.childMarkdownRemark?.html || ""}
              href={author?.permalink || ""}
              name={author?.name || ""}
              image={author?.image}
            />
          ))}
      </PostContentBodyDIV>
    </PostContentWrapperDIV>
  )

export default PostContent
